export enum BasketItemStatus {
  New = "New",
  DirectivesDone = "DirectivesDone",
  OptionsDone = "OptionsDone",
  Loading = "Loading", // Only for UI
}
